/**
 * 时间日期相关操作
 */


/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成 2018-09-23 11:54:16
 * @param datetime 国际化日期格式
 */
 export function format (datetime) {
  return formatWithSeperator(datetime, "-", ":");
}

/**
 * 时间格式化
 * 将 2018-09-23T11:54:16.000+0000 格式化成类似 2018/09/23 11:54:16
 * 可以指定日期和时间分隔符
 * @param datetime 国际化日期格式
 */
export function formatWithSeperator (datetime, dateSeprator, timeSeprator) {
  if (datetime != null) {
    const dateMat = new Date(datetime);
    const year = dateMat.getFullYear();
    const month = dateMat.getMonth() + 1;
    const day = dateMat.getDate();
    const hh = dateMat.getHours() < 10 ? "0"+dateMat.getHours() : dateMat.getHours();
    const mm = dateMat.getMinutes() < 10 ? "0"+dateMat.getMinutes() : dateMat.getMinutes();
    const ss = dateMat.getSeconds() < 10 ? "0"+dateMat.getSeconds() : dateMat.getSeconds();
    const timeFormat = year + dateSeprator + month + dateSeprator + day + " " + hh + timeSeprator + mm + timeSeprator + ss;
    return timeFormat;
  }
}


/**
 * 根据数字获取星期的中午描述
 * @param {*} weekdayNum 星期的数字：1~7
 * @returns 
 */
export function getWeekdayDesc_CN (weekdayNum) {
  let desc = null;
  switch (weekdayNum) {
    case 1:
      desc = "周一";
      break;
    case 2:
      desc = "周二";
      break;
    case 3:
      desc = "周三";
      break;
    case 4:
      desc = "周四";
      break;
    case 5:
      desc = "周五";
      break;
    case 6:
      desc = "周六";
      break;
    case 7:
      desc = "周日";
      break;

    default:
      break;
  }
  return desc;
}

/**
 * 获取当前星期几（1~7）
 * @param {*} weekdayNum 
 * @returns 
 */
export function getCurWeekday (weekdayNum) {
  var curDate = new Date();
  var day = curDate.getDay();
  if (day === 0) day = 7;
  return day;
}

/**
 * 对期间进行加减运算
 * @param {*} date 
 * @param {*} gap 天数
 * @returns 
 */
export function addDay (date , gap) {
  date.setDate(date.getDate() + gap);
  return date ;
}
/**
 * 判断是否同天
 * @param {*} date1 
 * @param {*} date2 
 * @returns 
 */
export function isSameDay (date1 , date2) {
  return date1.getFullYear() === date2.getFullYear() &&
  date1.getMonth() === date2.getMonth() &&
  date1.getDate() === date2.getDate();
}

/**
 * 判断两个日期相差多少天
 * @param {*} startDate 
 * @param {*} endDate 
 * @returns 
 */
export function getDistanceDay(startDate, endDate){
  var date3 = new Date(endDate).getTime() - new Date(startDate).getTime();   //时间差的毫秒数
  var days=Math.floor(date3/(24*3600*1000));
  return days;
}

export default {
  format,
  formatWithSeperator,
  getWeekdayDesc_CN,
  getCurWeekday,
  addDay,
  isSameDay,
  getDistanceDay

}



// WEBPACK FOOTER //
// ./src/utils/datetime.js